package com.macrofocus.eflux.animation

import com.macrofocus.common.properties.MutableProperty
import svgpanzoom.SvgPanZoomContext

class OnZoomAnimation(private val svgPanZoomContext: SvgPanZoomContext, private val property : MutableProperty<Boolean>, private val zoomThreshold: Double, override val duration: Long) :
    Animation {
    override fun start() {

    }

    override fun tick(time: Long) {
        property.value = svgPanZoomContext.getZoom() > zoomThreshold
    }
}